/** Side-panel Dock (DOCK-174): no launcher; toasts and the inline panel stay. */
export const LAUNCHER_HIDDEN_CSS = `
    .pw-launcher-hidden .pw-icon-stack,
    .pw-launcher-hidden .pw-fab-zone,
    .pw-launcher-hidden .pw-mini-tab {
      display: none !important;
    }
`;
